import { Component, Input, OnInit } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { DialogModalSize } from '../dialog/dialog-ref';
import { DialogService } from '../dialog/dialog.service';
import { ShowPdfComponent } from '../file-uploader/show-pdf/show-pdf.component';

@Component({
    selector: 'app-document-viewer-with-thumbnail',
    templateUrl: './document-viewer-with-thumbnail.component.html',
    styleUrls: ['./document-viewer-with-thumbnail.component.scss'],
    standalone: false
})
export class DocumentViewerWithThumbnailComponent implements OnInit {
  @Input() documentId: any;
  @Input() config: any={};
  @Input() item:any=false;
  private _currentData: any={};
  constructor(public dialogService: DialogService,public baseService:BaseService) { }

  ngOnInit(): void {
    if(this.config.showThumnail!=undefined && this.config.showThumnail){
      this.getUrl(this.documentId);
    }
   
  }

  showDocument(docId) {
    if (docId) {
      var item = docId;
      let obj = { data: { id: item }, title: 'View Document', size: DialogModalSize.Lg };
      this.dialogService.open(ShowPdfComponent, obj).afterClosed.subscribe(
        response => {

        }
      );
    }
  }

  getUrl(documentId) {
        this._currentData.imageUrl = this.baseService.getApiEndpoint("dms") + 'emrImage' + '/image-response-entity?args=id:' + documentId + '&application=dms';
    }
  


}
